import { getFetch } from "../../utils/fetch";

async function getCargoId() {
  const res = await getFetch(`/weight-bridges/getLatestCargoCode`);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function getMachineData(pelak) {
  const res = await getFetch(`/weight-bridges/getMachine?pelak=${pelak}`);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}


export {getCargoId,getMachineData};